import { useState } from "react";

export function useSmartOpenClients(initial = false) {
  const [openLastOpenedClients, setOpenLastOpenedClients] = useState(initial);

  const updateOpen = (value: string) => {
    const isEmpty = value.trim() === "";
    setOpenLastOpenedClients(isEmpty);
  };

  const closeLastOpenedClients = () => {
    setOpenLastOpenedClients(false);
  };

  return { openLastOpenedClients, closeLastOpenedClients, updateOpen };
}
